import {Pipe, PipeTransform, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {TranslatePipe as NgXTranslatePipe, TranslateService as NgXTranslateService} from '@ngx-translate/core';

/**
* **********************************************************************
* Pipe that wraps the pipe of ng2-translate.
*
* Written by: Dana Moshe
* **********************************************************************
*/
@Pipe({
	name: 'cpTranslate',
	pure: true
})
export class TranslatePipe implements PipeTransform, OnDestroy{
	public translate:NgXTranslatePipe;

	constructor(private ng2TranslateService:NgXTranslateService, private changeDetectorRef:ChangeDetectorRef) {
		this.translate = new NgXTranslatePipe(ng2TranslateService, changeDetectorRef);
	}

	public ngOnDestroy(): void {
		this.translate.ngOnDestroy();
	}

	transform(query: string, ...args: any[]):any {
		return this.translate.transform(query, ...args);
	}
}
